import { adminsApi } from 'services/apiSlices/adminsApi';
import { adminDashboardApi } from 'services/apiSlices/adminDashboardApi';
import { countriesApi, publicCountriesApi, regionsAPI } from 'services/apiSlices/countriesApi';
import { customizationApi } from 'services/apiSlices/customizationApi';
import { entrepreneursApi } from 'services/apiSlices/entrepreneurApi';
import { interestshipsApi } from 'services/apiSlices/interestshipsApi';
import { invitesApi } from 'services/apiSlices/invitesApi';
import { languagesApi } from 'services/apiSlices/languagesApi';
import { communityProfilesApi } from 'services/apiSlices/communityProfilesApi';
import { userApi } from 'services/apiSlices/userApi';
import { accountApi } from 'services/apiSlices/accountApi';
import { managementPanelApi } from 'services/apiSlices/managementPanelApi';
import { programsDashboardApi } from 'services/apiSlices/programsDashboardApi';
import { userTokenAPI } from 'services/apiSlices/userTokenApi';
import { demoTokenAPI } from 'services/apiSlices/demoTokenApi';
import { demoExamplesApi } from 'services/apiSlices/demoExamplesApi';
import { parrobotChatApi } from 'services/apiSlices/parrobotChat/parrobotChatApi';
import { organizationsApi } from 'services/apiSlices/organizationsApi';
import { pillsApi } from 'services/apiSlices/pillsApi';
import { pillCategoriesApi } from 'services/apiSlices/pillCategoriesApi';
import { pillToolsApi } from 'services/apiSlices/pillToolsApi';
import { positioningsApi } from 'services/apiSlices/positionings/positioningsApi';
import { workspaceApi } from 'services/apiSlices/workspaceApi';
import { benefitApi } from 'services/apiSlices/benefitApi';
import { deepDiveApi } from 'services/apiSlices/deepDiveApi';

// E & M Applications & Profile
import { entrepreneurApplicationApi } from 'services/apiSlices/applications/entrepreneurApplicationApi';
import { mentorApplicationApi } from 'services/apiSlices/applications/mentorApplicationApi';
import { areasOfExpertiseApi } from 'services/apiSlices/areasOfExpertiseApi';
import { areasOfInnovationApi } from 'services/apiSlices/areasOfInnovationApi';

// Programs
import { programsApi } from 'services/apiSlices/programs/programsApi';
import { publicProgramsApi } from 'services/apiSlices/programs/publicProgramsApi';
import { adminDashboardProgramsApi } from 'services/apiSlices/programs/adminDashboardProgramsApi';

// Projects
import { projectsApi } from 'services/apiSlices/projects/projectsApi';
import { publicProjectsApi } from 'services/apiSlices/projects/publicProjectsApi';
import { exploreProjectsApi } from 'services/apiSlices/projects/exploreProjectsApi';

// Teams
import { teamApi } from 'services/apiSlices/teamApi';

import { oauth2Api } from 'services/apiSlices/oauth2Api';
import { workExperienceApi } from 'services/apiSlices/workExperienceApi';
import { userLinkApi } from 'services/apiSlices/userLinkApi';

import { executiveSummaryApi } from 'services/apiSlices/executiveSummaryApi';
import { executiveSummaryMembersApi } from 'services/apiSlices/executiveSummaryMembersApi';
import { documentsApi } from 'services/apiSlices/documentsApi';
import { deepDiveLinkApi } from 'services/apiSlices/deepDiveLinkApi';
import { valuePropositionOutcomesApi } from 'services/apiSlices/valuePropositionOutcomeApi';
import { valuePropositionReasonsApi } from 'services/apiSlices/valuePropositionReasonApi';
import { valuePropositionPainsApi } from 'services/apiSlices/valuePropositionPainApi';
import { problemsApi } from 'services/apiSlices/problemApi';
import { educationExperienceApi } from 'services/apiSlices/educationExperienceApi';
import { featureApi } from 'services/apiSlices/featureApi';
import { attributeApi } from 'services/apiSlices/attributeApi';

export const middleware = [
  deepDiveLinkApi.middleware,
  deepDiveApi.middleware,
  benefitApi.middleware,
  adminsApi.middleware,
  adminDashboardApi.middleware,
  areasOfExpertiseApi.middleware,
  areasOfInnovationApi.middleware,
  countriesApi.middleware,
  publicCountriesApi.middleware,
  regionsAPI.middleware,
  customizationApi.middleware,
  entrepreneurApplicationApi.middleware,
  interestshipsApi.middleware,
  invitesApi.middleware,
  parrobotChatApi.middleware,
  entrepreneursApi.middleware,
  languagesApi.middleware,
  communityProfilesApi.middleware,
  userApi.middleware,
  accountApi.middleware,
  managementPanelApi.middleware,
  mentorApplicationApi.middleware,
  pillsApi.middleware,
  pillCategoriesApi.middleware,
  pillToolsApi.middleware,
  userTokenAPI.middleware,
  demoTokenAPI.middleware,
  demoExamplesApi.middleware,
  organizationsApi.middleware,
  positioningsApi.middleware,
  workspaceApi.middleware,

  // Programs
  programsApi.middleware,
  programsDashboardApi.middleware,
  publicProgramsApi.middleware,
  adminDashboardProgramsApi.middleware,

  // Projects
  projectsApi.middleware,
  publicProjectsApi.middleware,
  exploreProjectsApi.middleware,

  // Teams
  teamApi.middleware,

  oauth2Api.middleware,

  workExperienceApi.middleware,
  userLinkApi.middleware,
  executiveSummaryApi.middleware,
  executiveSummaryMembersApi.middleware,
  documentsApi.middleware,
  valuePropositionOutcomesApi.middleware,
  valuePropositionReasonsApi.middleware,
  valuePropositionPainsApi.middleware,
  problemsApi.middleware,
  educationExperienceApi.middleware,
  featureApi.middleware,
  attributeApi.middleware,
];
